export default __webpack_public_path__ + "static/media/logo.78404b53.svg";